import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from '../utils/api';
import PageHeader, { btnPrimary, cardClass } from '../components/PageHeader';
import SearchableSelect from '../components/SearchableSelect';

const Locations = () => {
  const [locations, setLocations] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [accountFilter, setAccountFilter] = useState('');
  const [showInactive, setShowInactive] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch('/admin/accounts?include_inactive=true').then((r) => setAccounts(r.data || []));
  }, []);

  useEffect(() => {
    setLoading(true);
    const q = new URLSearchParams();
    if (accountFilter) q.set('account_id', accountFilter);
    if (showInactive) q.set('include_inactive', 'true');
    apiFetch(`/admin/locations?${q}`)
      .then((r) => setLocations(r.data || []))
      .finally(() => setLoading(false));
  }, [accountFilter, showInactive]);

  return (
    <div>
      <PageHeader
        title="Service locations"
        subtitle="Properties where cleanings are performed"
        action={
          <Link to="/locations/new" className={btnPrimary}>
            New location
          </Link>
        }
      />

      <div className="flex flex-wrap gap-4 mb-4">
        <SearchableSelect
          value={accountFilter}
          onChange={setAccountFilter}
          options={accounts.map((a) => ({ value: a.id, label: a.name }))}
          placeholder="Filter by account…"
          allowEmpty
          emptyLabel="All accounts"
          className="max-w-xs"
        />
        <label className="flex items-center gap-2 text-sm text-slate-600">
          <input
            type="checkbox"
            checked={showInactive}
            onChange={(e) => setShowInactive(e.target.checked)}
          />
          Show inactive
        </label>
      </div>

      <div className={cardClass}>
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600 text-left">
            <tr>
              <th className="px-5 py-3">Label</th>
              <th className="px-5 py-3">Account</th>
              <th className="px-5 py-3">Address</th>
              <th className="px-5 py-3">Status</th>
              <th className="px-5 py-3" />
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5} className="px-5 py-8 text-center text-slate-500">
                  Loading…
                </td>
              </tr>
            ) : (
              locations.map((l) => (
                <tr key={l.id} className="border-t border-slate-100">
                  <td className="px-5 py-3 font-medium">{l.label || '—'}</td>
                  <td className="px-5 py-3">{l.account_name}</td>
                  <td className="px-5 py-3">
                    {l.address_line1}, {l.city}, {l.state} {l.postal_code}
                  </td>
                  <td className="px-5 py-3">{l.is_active ? 'Active' : 'Inactive'}</td>
                  <td className="px-5 py-3 text-right">
                    <Link to={`/locations/${l.id}/edit`} className="text-teal-700 hover:underline">
                      Edit
                    </Link>
                  </td>
                </tr>
              ))
            )}
            {!loading && locations.length === 0 && (
              <tr>
                <td colSpan={5} className="px-5 py-8 text-center text-slate-500">
                  No locations
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Locations;
